import HelpSearch from './help-search.js';

export default HelpSearch;
